import SuccessImage from '@/public/assets/success_pt_form.svg';
import EnrollButton from '@/app/components/core/EnrollButton';
import {
  CardFooter,
  CustomCard,
  LinksWrapper,
  StyledParagraph,
  StyledSectionHeader,
  TitleContent,
} from './styles';
import { replaceCopyKey } from '@/utils/replace-copy-key';
import { MarkdownRichText } from '@/app/_components/shared';
import { useContext, useMemo } from 'react';
import ClientContext from '@/contexts/client.context';
import { capitalize } from '@/utils/text';

const DESCRIPTION_REPLACEABLE_KEY = 'DATE';

const SuccessStep = ({ content, formData }) => {
  const { client, openModal } = useContext(ClientContext);

  const { title, description, footer, buttonLabel } = content;

  const composedString = useMemo(
    () => (formData?.bestDay ? `on **${capitalize(formData.bestDay)} ${formData?.bestTime}**` : ''),
    [formData?.bestDay, formData?.bestTime],
  );

  return (
    <CustomCard>
      <TitleContent>
        <SuccessImage />

        <StyledSectionHeader
          title={title}
          description={
            <MarkdownRichText elements={['bold']}>
              {replaceCopyKey(description, DESCRIPTION_REPLACEABLE_KEY, composedString)}
            </MarkdownRichText>
          }
          titleSize="xl"
          xAlign="center"
        />
      </TitleContent>

      <CardFooter>
        <StyledParagraph>{footer}</StyledParagraph>

        {buttonLabel && (
          <LinksWrapper>
            <EnrollButton
              id="predict-register-form-enroll-button"
              isActive={client.isActive}
              buttonLocation="predict-register-form"
              openModal={() =>
                openModal({
                  buttonText: buttonLabel,
                  buttonLocation: 'predict-register-form',
                })
              }
              client={client}
              buttonLabel={buttonLabel}
              product={client?.product}
            />
          </LinksWrapper>
        )}
      </CardFooter>
    </CustomCard>
  );
};

export default SuccessStep;
